import api from '@pray/shared/utils/api';

/** Undoes a soft delete (`destroyed = 0`). The server answers 204. */
export async function restoreContentSeries(artistId: string, contentSeriesId: string) {
  if (!artistId) throw Error('Artist ID is required');
  if (!contentSeriesId) throw Error('Content Series ID is required');

  const url = `/web/studio/artists/${artistId}/content-series/${contentSeriesId}/restore`;

  await api.executePutRequest(url);

  return { success: true };
}
